import apiClient from "../axios.config";

const bankDetailsServices = {
  postBankDetails(payload) {
    return apiClient.post("owner/bank/add", payload);
  },
  getBankDetails() {
    return apiClient.get("owner/bank/all");
  },
  getBankIDDetails(bankId) {
    return apiClient.get(`owner/bank/all/${bankId}`);
  },
  deleteBank(bankId) {
    return apiClient.delete(`owner/bank/delete/${bankId}`);
  },
  updateBankDetails(payload) {
    return apiClient.put("owner/bank/update", payload); // ✅ fixed double slash
  },
  markPrimary(bankId) {
    return apiClient.post(`owner/bank/bank/mark-primary?BankId=${bankId}`, {});
  },
};

export default bankDetailsServices;
